export enum UserType {
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  USER = 'User',
}
